import { Outlet, RouteObject } from 'react-router';

import { AppContainerWithMenu } from '@sternum/web/features/appContainerWithMenu';
import { ProtectedRoute } from '@sternum/web/routes/ProtectedRoute';
import { lazyImport } from '@sternum/web/utils/lazyImport';

import { fleetsViewPaths } from './paths';

const { FleetsViewView } = lazyImport(() => import('../views/fleetsView'), 'FleetsViewView');
const { AlertDetailsView } = lazyImport(() => import('../../alerts/views/alertDetails'), 'AlertDetailsView');
const { AttackDetailsView } = lazyImport(() => import('../../attacks/views/attackDetails'), 'AttackDetailsView');
const { AnomaliesDetailsView } = lazyImport(() => import('../../anomalies/views'), 'AnomaliesDetailsView');

function Layout() {
  return (
    <ProtectedRoute>
      <AppContainerWithMenu>
        <Outlet />
      </AppContainerWithMenu>
    </ProtectedRoute>
  );
}

export const fleetsViewRoutes: RouteObject[] = [
  {
    path: fleetsViewPaths.absolute,
    element: <Layout />,
    children: [
      { path: '', element: <FleetsViewView /> },
      { path: fleetsViewPaths.alertDetails.relative, element: <AlertDetailsView /> },
      { path: fleetsViewPaths.attackDetails.relative, element: <AttackDetailsView /> },
      { path: fleetsViewPaths.aiAnomaliesDetails.relative, element: <AnomaliesDetailsView /> },
    ],
  },
];
